import { lazy } from "react";

const AvailableCapacity = lazy(() => import("./page"));
const routes = [
  {
    path: "/dashboard/available-capacity",
    component: AvailableCapacity,
    exact: true,
    name: "Capacidad Disponible"
  }
];

export default routes;
